import { Container } from 'features/shared/ui/Page';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import OlympiadsList from './components/Olympiads/OlympiadsList';
import OlympiadsStatistic from './components/Olympiads/components/OlympiadsStatistic/OlympiadsStatistic';

const MAIN_PAGE_PATH = '/main';

const MainPage = () => {
  const match = useRouteMatch({ path: MAIN_PAGE_PATH, exact: false });
  const basePath = match?.path ?? MAIN_PAGE_PATH;

  return (
    <Container data-testid="main-page" style={{minHeight: '100%', height: '100%' }}>
      <Switch>
        <Route path={`${basePath}/olympiads/:olympiadId/statistic`}>
          <OlympiadsStatistic />
        </Route>
        <Route exact path={basePath}>
          <OlympiadsList />
        </Route>
      </Switch>
    </Container>
  );
};

export default MainPage;
